declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}

export const trackFacebookEvent = (event: string, payload?: Record<string, unknown>) => {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return;

  if (payload) {
    window.fbq('trackCustom', event, payload);
  } else {
    window.fbq('trackCustom', event);
  }
};
